const api_url = "https://clairity-api-tknmo7z3ha-uc.a.run.app/clairity";

export default api_url;